module.exports = __webpack_public_path__ + "static/Auto-Share-11-e1407759136627-805c7a1fe7da71240e71ea40430ac7a4.jpg";